import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip } from 'components';
import { GuideService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';

interface Props {
  title?: string;
  onClose?: any;
  item?: any;
  areas?: any;
  types?: any;
}

class CreateGuide extends React.Component<Props> {
  state = {
    form: {
      type_id: '',
      area_id: '',
      file: '',
      youtube_url: '',
      name: '',
    },
    areas: this.props.areas || [],
    types: this.props.types || [],
  };

  componentDidMount() {
    if (this.props.item) {
      this.setState({
        form: {
          ...this.state.form,
          name: this.props.item?.name || '',
          area_id: this.props.item?.area_id || '',
          type_id: this.props.item?.type_id || '',
          youtube_url: this.props.item?.youtube_video_id
            ? `https://www.youtube.com/watch?v=${this.props.item.youtube_video_id}`
            : '',
        },
      });
    }
  }

  isYoutube = () => Number(this.state.form.type_id) === Constants.GUIDE_TYPES.YOUTUBE;

  getYoutubeVideoId = () => {
    const match = (this.state.form.youtube_url || '').match(
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/,
    );
    return match ? match[1] : null;
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (!this.state.form.type_id) {
      Globals.showError('Para continuar, debe seleccionar el tipo de guía');
      return;
    }

    if (this.isYoutube()) {
      if (!this.state.form.youtube_url) {
        Globals.showError('Para continuar, debe ingresar el enlace del video de YouTube');
        return;
      }

      if (!this.getYoutubeVideoId()) {
        Globals.showError('El enlace de YouTube no es válido');
        return;
      }

      if (!this.state.form.name) {
        Globals.showError('Para continuar, debe ingresar un nombre para el video');
        return;
      }
    } else {
      if (!this.state.form.area_id) {
        Globals.showError('Para continuar, debe seleccionar el área');
        return;
      }

      if (!this.props.item && !this.state.form.file) {
        Globals.showError('Para continuar, debe seleccionar un archivo');
        return;
      }
    }

    const payload: any = {
      type_id: this.state.form.type_id,
    };

    if (this.isYoutube()) {
      payload.youtube_url = this.state.form.youtube_url;
      payload.name = this.state.form.name;
    } else {
      payload.area_id = this.state.form.area_id;
      payload.hasFile = true;
      // @ts-ignore
      payload.file = this.state.form.file?.value || '';
    }

    if (this.props.item != null) {
      await GuideService.admin.update({
        guide_id: this.props.item?.id,
        ...payload,
      });
      Globals.showSuccess('Se ha modificado la guía correctamente');
      this.props.onClose();
    } else {
      await GuideService.admin.create(payload);
      Globals.showSuccess('Se ha creado la guía correctamente');
      this.props.onClose();
    }
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  render() {
    const isYoutube = this.isYoutube();
    const videoId = isYoutube ? this.getYoutubeVideoId() : null;

    return (
      <div id='modal-create-guide'>
        <form onSubmit={this.submit}>
          <div className='container-inputs'>
            <div className='row'>
              <div className='col-md-12'>
                <Select
                  color='white'
                  placeholder='Seleccionar'
                  label='Tipo de Guía'
                  name='type_id'
                  onChange={this.change}
                  value={this.state.form.type_id}
                  options={this.state.types.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              {isYoutube ? (
                <div className='col-md-12'>
                  <Input
                    color='white'
                    label='Nombre del video'
                    placeholder='Ej. Cómo redactar un contrato de arrendamiento'
                    name='name'
                    onChange={this.change}
                    value={this.state.form.name}
                  />
                  <Input
                    color='white'
                    label='Enlace de YouTube'
                    placeholder='https://www.youtube.com/watch?v=...'
                    name='youtube_url'
                    onChange={this.change}
                    value={this.state.form.youtube_url}
                  />
                  {this.state.form.youtube_url && (
                    <div className='text-center' style={{ marginTop: 10 }}>
                      {videoId ? (
                        <img
                          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                          alt='Vista previa del video'
                          style={{ maxWidth: '100%', borderRadius: 8 }}
                        />
                      ) : (
                        <p style={{ color: '#d20b06' }}>El enlace de YouTube no es válido</p>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <div className='col-md-12'>
                    <Select
                      color='white'
                      placeholder='Seleccionar'
                      label='Tipo de derecho'
                      name='area_id'
                      onChange={this.change}
                      value={this.state.form.area_id}
                      options={this.state.areas.map((item: any) => {
                        return {
                          value: item.id,
                          label: item.name,
                        };
                      })}
                    />
                  </div>
                  <div className='col-md-12'>
                    <p>Puede subir documentos PDF</p>
                    <div className='text-center'>
                      <PaperClip
                        formats={['pdf']}
                        successText='Archivo adjunto'
                        pendingText={this.props.item == null ? `Subir archivo` : `Cambiar archivo`}
                        value={this.state.form.file}
                        onChange={(e: any) => {
                          this.setState({
                            form: {
                              ...this.state.form,
                              file: e.target,
                            },
                          });
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className='text-center'>
            <Button type='submit'>Guardar</Button>
          </div>
        </form>
      </div>
    );
  }
}

export default CreateGuide;
